/* PAWNOVA v6 – carosello, freccia indietro, video della storia */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Carosello prodotti ---------- */
  function initCarousel(root) {
    if (!root || root.__pnCar) return;
    var track = root.querySelector('[data-pn-track]');
    if (!track) return;
    root.__pnCar = true;
    var prev = root.querySelector('[data-pn-prev]');
    var next = root.querySelector('[data-pn-next]');
    var bar = root.querySelector('[data-pn-bar]');
    var ticking = false;

    function stepSize() {
      var slide = track.querySelector('.pn-car__slide');
      if (!slide) return track.clientWidth;
      var cs = w.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var unit = slide.getBoundingClientRect().width + gap;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / unit));
      return per * unit;
    }
    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      var overflow = max > 4;
      root.classList.toggle('is-static', !overflow);
      if (prev) prev.disabled = !overflow || x <= 4;
      if (next) next.disabled = !overflow || x >= max - 4;
      if (bar && track.scrollWidth > 0) {
        bar.style.width = Math.min(100, track.clientWidth / track.scrollWidth * 100) + '%';
        bar.style.transform = 'translateX(' + (track.clientWidth ? x / track.clientWidth * 100 : 0) + '%)';
      }
    }
    function schedule() { if (!ticking) { ticking = true; w.requestAnimationFrame(update); } }
    function go(dir) { track.scrollBy({ left: dir * stepSize(), behavior: reduce ? 'auto' : 'smooth' }); }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', schedule, { passive: true });
    w.addEventListener('resize', schedule);
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    /* Trascinamento con il mouse (solo desktop; su touch lo scroll è nativo) */
    var down = false, moved = false, startX = 0, startL = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startL = track.scrollLeft;
    });
    w.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startL - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      if (moved) {
        track.classList.remove('is-dragging');
        setTimeout(function () { moved = false; }, 0);
      }
    }
    w.addEventListener('pointerup', endDrag);
    w.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    update();
    w.addEventListener('load', update);
  }
  function initCarousels(scope) {
    (scope || d).querySelectorAll('[data-pn-car]').forEach(initCarousel);
  }

  /* ---------- Freccia "Indietro" ---------- */
  function initBack(scope) {
    (scope || d).querySelectorAll('[data-pn-back]').forEach(function (a) {
      if (a.__pnBack) return;
      a.__pnBack = true;
      a.addEventListener('click', function (e) {
        var ref = d.referrer, same = false;
        try { same = !!ref && new URL(ref).origin === w.location.origin && ref !== w.location.href; } catch (err) {}
        if (same && w.history.length > 1) { e.preventDefault(); w.history.back(); }
      });
    });
  }

  /* ---------- Video della sezione storia (caricamento pigro) ---------- */
  function loadVideo(v) {
    if (v.dataset.src && !v.getAttribute('src')) { v.setAttribute('src', v.dataset.src); v.load(); }
  }
  function playVideo(v) {
    if (reduce) return;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function initVideos(scope) {
    var vids = (scope || d).querySelectorAll('video[data-pn-video]');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.playsInline = true; });
    if (!('IntersectionObserver' in w)) { vids.forEach(function (v) { loadVideo(v); playVideo(v); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { loadVideo(v); playVideo(v); }
        else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '250px 0px', threshold: 0 });
    vids.forEach(function (v) { if (!v.__pnVid) { v.__pnVid = true; io.observe(v); } });
  }

  function init() { initCarousels(); initBack(); initVideos(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  /* Editor del tema: reinizializza le sezioni ricaricate */
  d.addEventListener('shopify:section:load', function (e) {
    initCarousels(e.target); initBack(e.target); initVideos(e.target);
    e.target.querySelectorAll('.pn-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
